import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { propBool, propStr } from '../../../helpers/custom-prop-types';
import SvgImage from './SvgImage';
const NoImage = (props) => {
    const { className, imageClass, isBlur, src, useImage } = props;
    if (!useImage && isBlur) {
        return (_jsx(SvgImage, { className: `${className} is-no-image is-image-bg`, isBlur: isBlur, isObjectFit: true, preserveAspectRatio: '', src: src }));
    }
    return (_jsx("div", Object.assign({ className: 'is-parent-wh is-image-bg is-flex-center' }, { children: _jsx(LazyLoadImage, { alt: '', className: `is-image-bg-icon ${className} ${imageClass}`, src: src }) })));
};
NoImage.propTypes = {
    className: propStr().isRequired,
    imageClass: propStr().isRequired,
    isBlur: propBool().isRequired,
    src: propStr().isRequired,
    useImage: propBool().isRequired,
};
export default NoImage;
